import { browserEnv } from '@/defines/environment'
import { goodDefaultImg } from '@/defines/environment/config'

// promise版setTimeout
export const waitTime = (interval = 0) => {
  return new Promise(resolve => {
    setTimeout(resolve, interval)
  })
}

export const dateTimeFormatter = (time, format) => {
  if (typeof time === 'number') {
    time = new Date(time)
  }
  const year = time.getFullYear()
  const month = time.getMonth()
  const day = time.getDate()
  const hours24 = time.getHours()
  const hours = hours24 % 12 === 0 ? 12 : hours24 % 12
  const minutes = time.getMinutes()
  const seconds = time.getSeconds()
  const milliseconds = time.getMilliseconds()
  const dd = t => ('0' + t).slice(-2)
  const map = {
    YYYY: year,
    MM: dd(month + 1),
    M: month + 1,
    DD: dd(day),
    D: day,
    HH: dd(hours24),
    H: hours24,
    hh: dd(hours),
    h: hours,
    mm: dd(minutes),
    m: minutes,
    ss: dd(seconds),
    s: seconds,
    S: milliseconds
  }
  return format.replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, str => map[str])
}

export const imgLoadFail = (e, defaultImg) => {
  if (defaultImg === 'HIDE') {
    e.target.style.display = 'none'
    return
  }

  defaultImg = defaultImg || getGoodDefaultImg()
  if (e.target.src !== defaultImg) {
    e.target.src = defaultImg
  }
}

/**
 * @description 比较一天内的时间先后,当第一个参数时间大于第二个参数时间时返回true
 * @param {*} from 比较时间参数1
 * @param {*} to 比较时间参数2
 */
export const compareTimeInOneDay = (from, to) => {
  if (from.getHours() < to.getHours()) {
    return false // 17:00:00 - 18:00:00
  } else if (from.getHours() > to.getHours()) {
    return true // 18:00:00 - 17:00:00
  } else {
    if (from.getMinutes() < to.getMinutes()) {
      return false // 17:05:00 - 17:10:00
    } else if (from.getMinutes() > to.getMinutes()) {
      return true // 17:10:00 - 17:05:00
    } else {
      if (from.getSeconds() < to.getSeconds()) {
        return false // 17:05:30 - 17:05:40
      } else {
        return true // 17:05:40(41) - 17:05:40
      }
    }
  }
}

export const resolveUrlParams = () => {
  let searchQueries = {}
  let hashQueries = {}
  const searchIndex = window.location.search.indexOf('?')
  const hashIndex = window.location.hash.indexOf('?')
  if (hashIndex !== -1) {
    hashQueries = window.location.hash
      .split('?')[1]
      .split('&')
      .reduce((prev, curr) => {
        const [key, value] = curr.split('=')
        return key && value !== undefined
          ? Object.assign(prev, {
              [key]: value
            })
          : prev
      }, {})
  }
  if (searchIndex !== -1) {
    searchQueries = window.location.search
      .slice(1)
      .split('&')
      .reduce((prev, curr) => {
        const [key, value] = curr.split('=')
        return key && value !== undefined
          ? Object.assign(prev, {
              [key]: value
            })
          : prev
      }, {})
  }
  const params = Object.assign({}, searchQueries, hashQueries)
  return params
}

/*
  滚动缓动类，每次滚动会清空上一次滚动
  onEnd: 滚动结束回调
*/
export class ScrollAnimate {
  constructor(data) {
    this.timer = null
    data = data || {}
    // 可能没有此函数
    this.requestAnimationFrame = window.requestAnimationFrame
      ? window.requestAnimationFrame.bind(window)
      : function (aniFunc) {
          window.setTimeout(aniFunc, 16)
        }
    this.cancelAnimationFrame = window.cancelAnimationFrame
      ? window.cancelAnimationFrame.bind(window)
      : window.clearTimeout
    this.onEnd = data.onEnd
    this.scrollName =
      {
        VERTICAL: 'scrollTop',
        HORIZONTAL: 'scrollLeft'
      }[data.direction] || 'scrollTop'
  }

  scrollTo({ el, start, end }) {
    let currTop = start
    const top = end
    let diff = (top - currTop) / 15
    diff = diff >= 0 ? Math.max(diff, 5) : Math.min(diff, -5)
    diff = Math.round(diff)

    const ant = () => {
      currTop = currTop + diff
      currTop = start <= top ? Math.min(currTop, top) : Math.max(currTop, top)
      el[this.scrollName] = currTop
      if (currTop === top) {
        // eslint-disable-line eqeqeq
        this.onEnd && this.onEnd()
        return
      }
      this.timer = this.requestAnimationFrame(ant)
    }
    this.cancelAnimationFrame(this.timer)
    ant()
  }
}

// 提取坐标
export const getPoint = evt => {
  // 移动端
  if (evt.touches || evt.changedTouches) {
    const touch = evt.touches[0] || evt.changedTouches[0]
    return {
      x: Math.round(touch.screenX),
      y: Math.round(touch.screenY)
    }
  }

  // pc端
  return {
    x: Math.round(evt.screenX),
    y: Math.round(evt.screenY)
  }
}

// 计算与x轴夹脚
export const getAngle = (start, end) => {
  const x = end.x - start.x
  const y = end.y - start.y
  return (Math.atan2(y, x) * 180) / Math.PI
}

/**
 * [数字保证小数位]
 */
export const numToFixed = (num, digit = 2) => {
  const _num = parseFloat(num)
  if (_num) {
    return _num.toFixed(digit)
  } else {
    return '0.00'
  }
}
/**
 * @description 获取当前时间几天内的开始时间和结束时间
 * @params 天数
 * @params 是否为秒级
 */
export const getStartAndEendTime = (num, isSecondLevel = true) => {
  let toData = new Date(new Date().toLocaleDateString()).getTime()
  const pastStart = toData - num * 3600 * 24 * 1000
  let pastEnd = pastStart + 24 * 60 * 60 * 1000 - 1
  if (isSecondLevel) {
    toData = parseInt(toData / 1000)
    pastEnd = parseInt(pastEnd / 1000)
  }
  return [pastEnd, toData]
}

// 打电话
export const makeCall = phoneNumber => {
  // eslint-disable-next-line camelcase
  if (browserEnv === 'baidu') {
    window.swan &&
      window.swan.webView.getEnv(res => {
        if (res.smartprogram) {
          return window.swan.makePhoneCall({ phoneNumber })
        }
        return (location.href = `tel:${phoneNumber}`)
      })
  }
  location.href = 'tel:' + phoneNumber
}

export const getGoodDefaultImg = () => {
  return goodDefaultImg
}
